function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "noun_logout_3069449");

var _ref3 = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.");

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "Welcome",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Desktop",
  transform: "translate(-28.000000, -950.000000)",
  fill: "#FFFFFF",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("g", {
  id: "noun_logout_3069449",
  transform: "translate(28.000000, 950.000000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M3.25,23 L9.75,23 C11.542155,23 13,21.5931286 13,19.8636364 L13,15.6818182 C13,15.10447 12.5154623,14.6363636 11.9166667,14.6363636 C11.3178711,14.6363636 10.8333333,15.10447 10.8333333,15.6818182 L10.8333333,19.8636364 C10.8333333,20.4399636 10.3477376,20.9090909 9.75,20.9090909 L3.25,20.9090909 C2.65226238,20.9090909 2.16666667,20.4399636 2.16666667,19.8636364 L2.16666667,3.13636364 C2.16666667,2.56003643 2.65226238,2.09090909 3.25,2.09090909 L9.75,2.09090909 C10.3477376,2.09090909 10.8333333,2.56003643 10.8333333,3.13636364 L10.8333333,7.31818182 C10.8333333,7.89553001 11.3178711,8.36363636 11.9166667,8.36363636 C12.5154623,8.36363636 13,7.89553001 13,7.31818182 L13,3.13636364 C13,1.40687142 11.542155,0 9.75,0 L3.25,0 C1.45784502,0 0,1.40687142 0,3.13636364 L0,19.8636364 C-4.81096644e-16,21.5931286 1.45784513,23 3.25,23 Z",
  id: "Path"
}), /*#__PURE__*/React.createElement("path", {
  d: "M7,12.5 C7,13.0916923 7.47525732,13.5714286 8.0625841,13.5714286 L20.3736171,13.5714286 L15.8119767,18.171038 C15.3969048,18.5895648 15.3969048,19.2675782 15.8119767,19.686105 C16.0195128,19.8953684 16.2913849,20 16.5632569,20 C16.835129,20 17.1070012,19.8953683 17.3145372,19.6861049 L23.6893284,13.2582528 C23.7876485,13.1593105 23.8655393,13.0406842 23.9194987,12.9091753 C24.0268338,12.6474652 24.0268338,12.3525346 23.9194987,12.0908247 C23.8655393,11.9593157 23.7876485,11.8406895 23.6893284,11.7417471 L17.3145372,5.31389509 C16.8994652,4.8953683 16.2270487,4.8953683 15.8119768,5.31389509 C15.3969049,5.73242187 15.3969049,6.41043526 15.8119768,6.82896205 L20.3736171,11.4285715 L8.0625841,11.4285715 C7.47525742,11.4285715 7,11.9083078 7,12.5 Z",
  id: "Path"
}))));

var SvgLogout = function SvgLogout(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "23px",
    viewBox: "0 0 24 23",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLogout, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Logout.865862d9.svg";
export { ForwardRef as ReactComponent };